<div class="app-shell d-flex flex-column">
  @if (user$ | async; as user) {
    <!-- Top navbar -->
    <div class="w-100" style="z-index: 200; flex-shrink: 0;">
      <app-menubar-layout></app-menubar-layout>
    </div>

    <!-- Main scrollable content -->
    <main class="flex-grow-1">
      @if (staticDataService.isAppLoaded) {
        <router-outlet></router-outlet>
      } @else {
        <div class="erp-loading-overlay" style="min-height: 70vh;">
          <img
            src="assets/media/logos/mavles/logo-mavles-full.png"
            class="mb-4"
            style="max-height: 64px; opacity: 0.8;"
            alt="Mavles"
          />
          <div class="spinner-border"></div>
          <p>Loading application data…</p>
        </div>
      }
    </main>

    <app-alert></app-alert>
    <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
  } @else {
    <app-login></app-login>
  }
</div>
